import React from 'react';
import Avatar from 'seedly-component-library/avatar-new';
import JoinGroupButton from 'components/group/JoinGroupButton';
import NextImage from 'next/image';
import formatCount from 'utils/formatCount';
import { Group } from 'entity/group/groupRedux';
import useIsMobile from 'utils/hooks/useIsMobile';

/* eslint-disable jsx-a11y/accessible-emoji */
const GroupJumbotron = (props: { group: Group }) => {
  const {
    id,
    coverImage,
    profileImage,
    name,
    membersCount,
    discussionsCount,
    description,
    followedByCurrentUser,
    isToggling,
    slug,
  } = props.group;

  const isMobile = useIsMobile();

  return (
    <div className="card bg-neutral-100 p-0" data-testid="group-jumbotron-card">
      <div className="w-full relative mb-[26px]">
        <NextImage
          className="rounded-none lg:rounded-t-lg"
          priority
          src={coverImage}
          layout={isMobile ? 'responsive' : 'fixed'}
          height={240}
          width={644}
          alt="group-banner"
        />
        <div
          className="absolute left-4 bottom-[-26px]"
          data-testid="group-avatar"
        >
          <Avatar src={profileImage} sizeClass="avatar-16" />
        </div>
      </div>
      <div className="flex flex-col w-full gap-4 p-4">
        <div className="flex w-full justify-between">
          <p data-testid="group-title" className="text-xl font-bold">
            {name}
          </p>
          {slug !== 'announcements' && (
            <JoinGroupButton
              followedByCurrentUser={followedByCurrentUser}
              id={id}
              isLoading={isToggling}
            />
          )}
        </div>
        <p className="text-neutral-600">{description}</p>
        <div className="flex gap-8 items-center">
          {slug !== 'announcements' && (
            <p>
              <span className="mr-1" role="img" aria-label="face">
                🤓
              </span>
              {formatCount(membersCount)} Members
            </p>
          )}
          <p>
            <span className="mr-1" role="img" aria-label="think">
              💬
            </span>
            {formatCount(discussionsCount)} Discussions
          </p>
        </div>
      </div>
    </div>
  );
};

export default GroupJumbotron;
